import React, { useState, useEffect } from 'react';
import { Form, Input, Select, BackTop } from 'antd';
import { useTranslation } from 'react-i18next';
import IconEmailTemplate from '../../../../assets/Images/icons/icon-email-template';
import IconEmailTemplateRight from '../../../../assets/Images/icons/icon-email-template-right';
import IconWhiteFactLogo from '../../../../assets/Images/icons/icon-email-template-logo';
import IconEmailTemplatActive from '../../../../assets/Images/icons/icon-email-template-active';

export default function TemplateEmailCancel({
    form,
    detail,
    emailList,
    operationList,
}) {
    const { t } = useTranslation();

    const { TextArea } = Input;

    const [operations, setOperations] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const filteredOptions = emailList.filter((o) => !selectedItems.includes(o));

    useEffect(() => {
        setSelectedItems(emailList);
        setOperations(operationList);
        form.setFieldsValue({
            emailAssigneesTo: emailList,
            noteInPreview:
                'เจ้าหน้าที่แผนก.... ตรวจสอบแล้วพบว่าไม่สามารถดำเนินการได้ เนื่องจาก.....',
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [emailList, operationList]);

    const _getTagOperationStatus = (e) => {
        switch (e) {
            case 'Doing':
                return {
                    color: '#F9C153',
                };
            case 'Task Done':
                return {
                    color: '#4ACE8F',
                };
            case 'Task Canceled':
                return {
                    color: '#F0536F',
                };
            case 'Task Canceling':
                return {
                    color: '#65707A',
                };
            case 'To Do':
                return {
                    color: '#1890FF',
                };
            default:
                return { color: '#FFF' };
        }
    };

    return (
        <>
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            {/* {template2} */}
            <div className="col-span-1 bg-white h-max rounded-t-lg">
                <div
                    className="px-8 py-4 text-[#7B67FB] text-[16px] font-semibold"
                    style={{ borderBottom: '1px solid #ECECEC' }}
                >
                    อีเมลส่งถึงผู้ที่มอบหมายงาน
                </div>
                <div className="grid grid-cols-12 gap-2">
                    <div className="col-span-12 px-8">
                        <Form.Item
                            name={'emailAssigneesTo'}
                            className="mt-2 mb-2"
                            label={
                                <span className="text-[14px] text-[#65707A] text-left">
                                    {t('to')}
                                </span>
                            }
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                            ]}
                        >
                            <Select
                                mode="multiple"
                                placeholder={t('MyTask.PleaseSelect')}
                                value={selectedItems}
                                onChange={setSelectedItems}
                                style={{
                                    width: '77%',
                                }}
                            >
                                {filteredOptions.map((item) => (
                                    <Select.Option key={item} value={item}>
                                        {item}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <div className="flex justify-between">
                            <div className="text-[14px] text-[#65707A]">
                                cc : -
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="px-44 py-14 text-[16px] bg-[#ECECEC] rounded-b-lg mb-4">
                <div className="text-center my-2">
                    <IconWhiteFactLogo />
                </div>
                <div className="p-8 text-[16px] bg-white rounded-lg">
                    <div className="text-[14px] font-semibold">
                        คำขอใช้สิทธิหมายเลข
                        <span className="text-[#1890FF]">
                            {' '}
                            {detail?.requestId || '-'}{' '}
                        </span>
                        มีแผนกที่ยกเลิกงาน โปรดตรวจสอบว่าจะยืนยันให้ยกเลิก
                    </div>
                    <div className="text-[14px] font-semibold">
                        {' '}
                        หรือมอบหมายงานอีกครั้ง
                    </div>

                    <div className="text-[14px] font-semibold my-2">
                        ดำเนินการโดยแผนก
                    </div>
                    {operations?.map((e) => (
                        <>
                            <div className="py-1 px-4 bg-[#F5F6FF] my-1 rounded">
                                <div className="grid grid-cols-10 gap-2 p-1">
                                    <div className="flex items-center col-span-2">
                                        <div
                                            className="rounded-xl -my-1 text-center w-full text-[12px] bg-white"
                                            style={{
                                                color: _getTagOperationStatus(
                                                    e?.taskStatusName
                                                ).color,
                                                borderColor:
                                                    _getTagOperationStatus(
                                                        e?.taskStatusName
                                                    ).color,
                                                border: '1px solid',
                                            }}
                                        >
                                            {e?.taskStatusName}
                                        </div>
                                    </div>
                                    <div className="flex items-center col-span-2">
                                        <div className="text-[12px] font-semibold">
                                            {e?.departmentName || '-'}
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-end col-span-6">
                                        <div className="text-[12px] font-semibold space-x-2">
                                            <span>Operation Person : </span>
                                            <span className="font-normal">
                                                {e?.operationPersonName === '-'
                                                    ? 'Waiting for a response'
                                                    : e?.operationPersonName ||
                                                      'Waiting for a response'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ))}

                    <div className="text-[14px] font-semibold mt-4 mb-1">
                        ข้อมูลเพิ่มเติม
                    </div>
                    <Form.Item className="mt-2" name={'noteInPreview'}>
                        <TextArea
                            size="large"
                            className="bg-[#F4F6FC]"
                            autoSize={{ minRows: 3, maxRows: 4 }}
                            placeholder={t('MyTask.DescribeDetails')}
                        />
                    </Form.Item>

                    <div className="text-[14px] font-semibold my-4">
                        ดูรายละเอียดเพิ่มเติมและเริ่มทำงานได้ที่เมนู Data
                        Subject 360 {'>'}{' '}
                        <span className="text-[#7B67FB]">My Task</span>
                    </div>

                    <div
                        className="my-4"
                        style={{ borderBottom: ' 2px solid #F5F6FF' }}
                    ></div>
                    <div className="p-4 text-center text-[12px]">
                        Copyright © 2022 Whitefact
                    </div>
                </div>
            </div>
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
